import React from "react";

const KPMark = () => {
    return (
        <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M0 2.66667C0 1.194 1.194 0 2.66667 0H16L0.000317574 15.9997L16 31.9993H2.66667C1.194 31.9993 0 30.8053 0 29.3327L0.000317574 15.9997L0 2.66667Z" fill="#EEEEEE"/>
            <path d="M16 18.666L16 31.9993L31.9997 15.9997L32 2.66667C32 1.194 30.806 0 29.3333 0H16L31.9997 15.9997L18.6667 15.9994C17.194 15.9994 16 17.1934 16 18.666Z" fill="#EEEEEE"/>
        </svg>
    )
}

export default KPMark;